"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeAccessor = void 0;
var ramda_1 = require("ramda");
var themeAccessor = function (keys) {
    if (keys === void 0) { keys = []; }
    return function (props) { return ramda_1.path(__spreadArrays(keys), props.theme); };
};
exports.themeAccessor = themeAccessor;
